<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[460px] w-full text-center flex-grow px-4">
      <h2 class="mt-5 mt-10 mb-6 text-center">
        {{ $t("messages.wait_disable_2fa.title") }}
      </h2>
      <div class="bg-white rounded-lg">
        <div class="flex mb-4 text-left">
          <img
            class="ml-6 mt-6 h-12 w-12"
            src="@/assets/svg/icon_48px_send.svg"
            alt=""
          >
          <div class="ml-4 mt-6 mr-6">
            <span class="b1 text-zyxel-gray-800 font-bold">{{ $t('messages.common.hint_send_email_to') }}</span><br>
            <span class="b1 text-zyxel-gray-800 font-bold break-all whitespace-normal">{{ toEmail }}</span>
          </div>
        </div>
        <p class="b1 block text-left text-zyxel-gray-800 ml-6 mr-6 mb-8 pb-6">
          {{ $t("messages.wait_disable_2fa.description") }}
        </p>
      </div>
      <div class="mt-4 mb-6 sm:flex sm:justify-center sm:items-center">
        <span
          class="mr-4 b1 text-zyxel-gray-800"
          style="color: #575757"
        >{{
          $t('messages.common.hint_not_receive_yet') }}</span>
        <div
          v-if="loading"
          class="loader"
        />
        <div v-else>
          <button
            class="b1 text-zyxel-green-700 cursor-pointer"
            style="border: none; background: none; padding: 0; outline: none;"
            @click="sendDisable2FA"
          >
            {{ $t("messages.common.link_send_again") }}
          </button>
        </div>
      </div>
    </div>
    <ZyxelFooter />
  </div>
</template>
<script>
import { useAuthStore } from '@/stores/auth';
import { useRoute } from 'vue-router';
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";
import { logger } from '@/utils/logger';

export default {
    name: 'WaitDisable2FAPage',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter,
    },
    setup() {
        const route = useRoute();
        const toEmail = route.query.to_email;

        return { toEmail };
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        async sendDisable2FA() {
            try {
                this.loading = true;
                const auth = useAuthStore();
                await auth.disable2FA();
                setTimeout(() => {
                    this.loading = false;
                }, 2000);
            } catch (error) {
                logger.error('Error during disable 2FA:', error);
                this.loading = false;
            }
        }
    }
}
</script>